import { useMemo } from 'react'
import { useModelVisibilityV2 } from '@scene'
import { v4 } from 'uuid'
import { ThreeEvent } from '@react-three/fiber'
import useModelSelectionV2 from '../hooks/useModelSelectionV2'
import usePositionHighlighting from '../hooks/usePositionHighlighting'
import usePositionTargets from '../hooks/usePositionTargets'

interface Props {
  guid: string
  visible?: boolean
  /**
   *
   * @param guid
   * @param event
   * @returns Return the expected config after running the callback. You can use
   * this to show a faster response of selecteion/visibility changes to the user
   * as we do not have to wait for the state to be updated.
   */
  onClick?: (guid: string, event: ThreeEvent<MouseEvent>) => void | { selectedGuids?: string[] }
  selected?: boolean

  highlighted?: boolean
  target?: boolean
}

const emptyArray: string[] = []

const PositionMeshConnector = ({
  guid,
  visible = true,
  selected = false,
  highlighted = false,
  target = false,
}: Props): null => {
  const stateId = useMemo(() => v4(), [])

  const selectedGuids = useMemo(() => {
    return selected ? [guid] : emptyArray
  }, [selected, guid])

  const hiddenGuids = useMemo(() => {
    return visible ? emptyArray : [guid]
  }, [visible, guid])

  const highlightedPositions = useMemo(() => {
    return highlighted ? [guid] : emptyArray
  }, [highlighted, guid])

  const targetPositions = useMemo(() => {
    return target ? [guid] : emptyArray
  }, [target, guid])

  usePositionHighlighting(highlightedPositions, stateId)
  usePositionTargets(targetPositions, stateId)
  useModelSelectionV2(selectedGuids, stateId)
  useModelVisibilityV2(hiddenGuids, stateId)

  return null
}

export default PositionMeshConnector
